// 统一请求路径前缀在libs/axios.js中修改
import {getRequest, postRequest, putRequest, deleteRequest, uploadFileRequest} from '@/libs/axios';


// 添加
export const addLecturer = (params) => {
    return postRequest('/base/lecturer/add', params)
}

// 修改
export const editLecturer = (params) => {
    return postRequest('/base/lecturer/edit', params)
}
// 删除
export const delLecturer = (ids) => {
    return postRequest("/base/lecturer/delByIds",{
        ids: ids
    })
}

// 列表
export const lecturerList = (params) => {
    return postRequest('/base/lecturer/list', params)
}

// 获取单个对象
export const getLecturer = (id) => {
    return postRequest(`/base/lecturer/get/${id}`)
}

//更新上架状态
export const setIsShow = (params) => {
    return postRequest('/base/lecturer/setIsShow', params)
}